export default __webpack_public_path__ + "static/media/purple-spiral.5749b41e.svg";